<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="true" *ngIf="isModalWindow"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1" *ngIf="isModalWindow">
  <div class="container-fluid m-b-lg ">
    <div class="row m-t-sm">
      <div class="col-12 p-0">
        <input pInputText class="p-inputtext" type="text" placeholder="{{ 'Tasks.taskFiltersPlaceholder' | translate }}"
          name="subFilterText" id="subFilterTextInput" (ngModelChange)="updateFilter()" autocomplete="off" tabindex="1"
          [(ngModel)]="this.subFilterText" label="Filtro" />
      </div>
    </div>
    <ng-container *ngTemplateOutlet="list"></ng-container>
  </div>
</p-scrollPanel>
<ng-container *ngIf="!isModalWindow">
  <ng-container *ngTemplateOutlet="list"></ng-container>
</ng-container>
<ng-template #list>
  <ng-container *ngIf="tasksList">
    <p-table #tareas [value]="tasksList" rowGroupMode="{{getGroupField()?.code?'subheader':undefined}}"
      groupRowsBy="{{getGroupField ()?.code}}" [rows]="15" [paginator]="!getGroupField()?.code" [pageLinks]="4"
      [rowsPerPageOptions]="[15, 30, 60, 100]" class="footer-over-pagination" (onPage)="outputCountersData()"
      sortField="arrivalDate" sortOrder="-1" [scrollable]="false" responsiveLayout="scroll"
      dataKey="{{getGroupField ()?.code}}" [(expandedRowKeys)]="expandedRowKeys">
      <ng-template pTemplate="header">
        <tr>
          <th class="col-icon text-center"></th>
          <th [pSortableColumn]="'description'" style="width:75%" [pSortableColumn]="'description'">{{
            'PendingTasks.description' | translate }} </th>
          <th [pSortableColumn]="'arrivalDate'" class="d-none d-md-table-cell  text-center" style="width:110px"> {{
            'PendingTasks.arrival' | translate }} <p-sortIcon [field]="'arrivalDate'" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
          <th [pSortableColumn]="'expirationDate'" class="d-none d-md-table-cell  text-center" style="width:110px"> {{
            'PendingTasks.endDate' | translate }} <p-sortIcon [field]="'expirationDate'" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
            </p-sortIcon>
          </th>
          <th class="text-center action-column" *ngIf="!this.readonlyParam"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="groupheader" let-task let-expanded="expanded">
        <tr pRowGroupHeader class="headerGroupTR">
          <td colspan="5" class="headerGroupTD" style="background-color: lightgrey; cursor:pointer;"
            (click)="expand(task, expanded)">
            <!-- [pRowToggler]="task" -->
            <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain p-mr-2"
              [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
            <span class="p-text-bold p-ml-2">
              <i class="fa " [ngClass]="getGroupField()?.icon" aria-hidden="true"></i> {{getGroupInfo (task)}}</span>
            <span style="margin-left: 10px;" class="badge badge-filter font-weight-normal">{{calculateTaskTotal
              (getGroupInfo (task))}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-task let-rowIndex="rowIndex">
        <ng-container *ngTemplateOutlet="cuerpoTabla; context: { task: task, rowIndex: rowIndex }"></ng-container>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-task let-rowIndex="rowIndex" *ngIf="getGroupField ()?.code">
        <ng-container *ngTemplateOutlet="cuerpoTabla; context: { task: task, rowIndex: rowIndex }"></ng-container>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="text-center">
          <td colspan="5">{{ 'General.noFilteredData' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</ng-template>

<ng-template #cuerpoTabla let-task="task" let-rowIndex="rowIndex">
  <tr>
    <!-- COLUMNA ICONO -->
    <td class="text-center">
      <span class="d-inline-block"><i [class]="getTaskIcon(task)" class="fa-lg "></i>
      </span>
    </td>
    <!-- COLUMNA Descripcion -->
    <td>
      <a (click)="openTask(task)">
        <!-- 1. DESCRIPCION DE LA TAREA CON ENLACE DE PAERTURA SI LA TAREA ESTA ACTIVA -->
        <div class="taskName {{this.userService.hasInbox(task.inbox.identifier)?' text-primary':''}}"> {{
          task?.description }} <span
            *ngIf="this.userPrefs && this.userPrefs.tasksViewPrefs && this.userPrefs.tasksViewPrefs.showProfile && task.profile"
            class="badge badge-light border border-secondary ml-2 pt-0 pb-0"><small> {{ getTaskProfile(task) }}
            </small></span>
        </div>
        <!-- 2. DATOS DEL EXPEDIENTE Y ESTRUCTURA DE DIVISIONES -->
        <div class="taskDetailInfo">
          <divisionDetail class="taskDossier" [division]="task.division" [showDivisionInfo]="true" [infoLink]="false">
          </divisionDetail>
        </div>
        <!-- 3. SI LA TAREA ESTA BLOQUEADA DATOS DEL USUARIO QUE TIENE LA TAREA -->
        <div class="taskDetailInfo" *ngIf="task?.status == 'LOCKED' && task?.lockedBy">
          <span>
            <i class="fa fa-lock text-danger" aria-hidden="true"></i> {{ 'Tasks.lockedBy' | translate }}: {{
            userService.calculateUserFullName(task?.lockedBy) }} </span>
        </div>
      </a>
      <!-- 4. EN MOVIL FECHAS DE LLEGADA Y VENCIMIENTO -->
      <div class="d-md-none">
        <div class="taskDetailInfo">
          <b>{{ 'PendingTasks.arrival' | translate }}:</b> {{ task.arrivalDate | date: 'dd/MM/yy HH:mm' }}
        </div>
        <div class="taskDetailInfo" *ngIf="task.expirationDate">
          <b>{{ 'PendingTasks.endDate' | translate }}:</b>
          <span> {{ task.expirationDate | date: 'dd/MM/y HH:mm' }} </span>
        </div>
      </div>
    </td>
    <!-- COLUMNA fecha llegada -->
    <td class="d-none d-md-table-cell"> {{ task.arrivalDate | date: 'dd/MM/y HH:mm' }} </td>
    <!-- COLUMNA fecha expiracion -->
    <td class="d-none d-md-table-cell ">
      <span *ngIf="task.expirationDate"> {{ task.expirationDate | date: 'dd/MM/y HH:mm' }} </span>
      <span *ngIf="!task.expirationDate" class=""> - </span>
    </td>
    <!-- COLUMNA acciones -->
    <td *ngIf="!this.readonlyParam">
      <task-actions [task]="task" [usuid]="this.usuidParam" [inboxid]="this.inboxIdParam">
      </task-actions>
    </td>
  </tr>
</ng-template>